module.exports = __webpack_public_path__ + "media/images/pie/pings-6362869ddd10f7687c61e93962a3fdf7.png";